import { render } from "./ServiceCategoriesView.vue?vue&type=template&id=8ac397fe"
import script from "./ServiceCategoriesView.vue?vue&type=script&lang=js"
export * from "./ServiceCategoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__